var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMapPin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 11,
  height: 13,
  fill: "none",
  viewBox: "0 0 11 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#7F7F7F",
  fillRule: "evenodd",
  d: "M5.5 4c-.551 0-1 .449-1 1a1.001 1.001 0 0 0 2 0c0-.551-.448-1-1-1m0-3c-2.206 0-4 1.838-4 4.099 0 3.097 3.02 5.958 3.993 6.801.97-.875 4.007-3.847 4.007-6.801C9.5 2.839 7.706 1 5.5 1m0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .898 2 2c0 1.103-.897 2-2 2m.303 5.892a.48.48 0 0 1-.597.008C5.014 12.752.5 9.229.5 5.077.5 2.277 2.743 0 5.5 0s5 2.278 5 5.077c0 3.968-4.506 7.66-4.697 7.815",
  clipRule: "evenodd",
  opacity: 0.7
})));
export default SvgMapPin;